import { forwardRef, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { Button, ButtonVariant } from '@shared/ui/Button'
import { Input, type InputProps } from '@shared/ui/Input/Input'

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type' | 'rightIcon'>>(
  (props, ref) => {
    const [visible, setVisible] = useState(false)

    return (
      <Input
        ref={ref}
        {...props}
        type={visible ? 'text' : 'password'}
        placeholder={props.placeholder ?? '••••••••'}
        rightIcon={
          <Button
            type="button"
            tabIndex={-1}
            onClick={() => setVisible((v) => !v)}
            variant={ButtonVariant.ghost}
            className="h-auto border-0 p-0 hover:bg-transparent"
          >
            {visible ? <EyeOff size={20} /> : <Eye size={20} />}
          </Button>
        }
      />
    )
  }
)
PasswordInput.displayName = 'PasswordInput'
